import { useEffect } from 'react';

import { useCustomerSheetPaymentElementCredentialsMutation } from './graphql/CustomerSheetPaymentElementCredentials.generated';

export const useCustomerSheetPaymentElementCredentials = () => {
  const [response, createCredentials] = useCustomerSheetPaymentElementCredentialsMutation();

  useEffect(() => {
    void createCredentials({});
  }, [createCredentials]);

  const result = response.data?.createCustomerSheetPaymentElementCredentials;
  const isFetching = response.fetching;
  const hasError = Boolean(response.error);

  const customerId = result?.id;
  const clientSecret = result?.clientSecret;
  const customerSessionClientSecret = result?.customerSessionClientSecret;

  return {
    customerId,
    clientSecret,
    customerSessionClientSecret,
    isFetching,
    hasError,
  };
};
